exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._24TEIPIVqYbE9R{margin:20px 8px 16px 56px}._2UTQF_WDvGs7lE{color:#5e6c84;font-size:12px;font-weight:500;letter-spacing:.04em;margin-top:16px;text-transform:uppercase;line-height:20px;margin:0 8px 4px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}._3sxScsVYlDxsGe{display:flex;flex-wrap:wrap;grid-gap:6px}.suDvQqiEYWLIce{cursor:pointer}._1OaYI6LISzNdFJ{cursor:pointer;float:left;margin:2px}._1mp3nTCLNxEkDU{text-align:center}.wTKm3VS-_EORlj{border-radius:0!important;height:256px!important;width:256px!important}._1yfKLM5yINrnwC{margin-left:64px}._8oQaRPb5uC0MAj{color:#172b4d;font-size:16px;font-weight:600;letter-spacing:-.006em;line-height:20px;margin-top:24px;margin:0 40px 0 0}._8oQaRPb5uC0MAj a{text-decoration:none}._8oQaRPb5uC0MAj a:hover{text-decoration:underline}._1mbh7ihwPwHXPk,._2X1Uhfq6R8DFp7{color:#5e6c84}._3Ku_7-aJrkYDj1{color:#5e6c84;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._2g3qEJPm8h0yI6{position:absolute;top:10px;right:10px}", ""]);

// exports
exports.locals = {
	"labelSection": "_24TEIPIVqYbE9R",
	"heading": "_2UTQF_WDvGs7lE",
	"members": "_3sxScsVYlDxsGe",
	"avatar": "suDvQqiEYWLIce",
	"popoverSmallAvatar": "_1OaYI6LISzNdFJ",
	"popoverLargeAvatarContainer": "_1mp3nTCLNxEkDU",
	"popoverLargeAvatar": "wTKm3VS-_EORlj",
	"memberDetails": "_1yfKLM5yINrnwC",
	"memberName": "_8oQaRPb5uC0MAj",
	"memberUsername": "_1mbh7ihwPwHXPk",
	"memberEmail": "_2X1Uhfq6R8DFp7",
	"memberBio": "_3Ku_7-aJrkYDj1",
	"closePopoverButton": "_2g3qEJPm8h0yI6"
};